import { reactive } from 'vue'

// Reactive breadcrumb store. Pages can call `breadcrumbState.set([...])` to
// provide a custom trail for the top bar. Each item is { label, to? }.
// `to` is an optional router path; when omitted the item renders as the
// current (non-clickable) page.
export const breadcrumbState = reactive({
  items: [],
  set(items) {
    this.items = Array.isArray(items) ? items : []
  },
  clear() {
    this.items = []
  },
})
